import api from '../index'

/**
 * 企业微信相关接口
 */

export default {
  // 获取企业微信配置
  getConfig: () => {
    return api.get('/wecom/getConfig')
  },
  // 获取企业微信JS-SDK配置
  getConfigSignature: (url: string) => {
    return api.get('/wecom/getConfigSignature', { params: { url } })
  },
}
